import styled from 'styled-components'

export const Title = styled.h2`
  margin-top: 20px;
  margin-bottom: 0px;
`
